import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type User from 'modules/core/store/models/User'

import { employeeLocation } from 'modules/locations/store/collections/locations'

interface LocationProps {
  user: User
}

function Location({ user }: LocationProps) {
  const location = user.employee ? employeeLocation(user.employee.attributes.location_id) : null

  if (!location) return <>-</>

  return <Text.Normal>{location.attributes.name}</Text.Normal>
}

export default observer(Location)
